import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { locales } from './locales/langs'
import 'bootstrap' // Import js file
import 'bootstrap/dist/css/bootstrap.min.css' // Import css file
import './assets/styles/main.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faBars, faArrowDown, faArrowRight, faTimes, faChevronRight, faEnvelopeOpenText, faEnvelope, faCheckCircle, faTimesCircle, faSignInAlt, faSignOutAlt, faBookOpen } from '@fortawesome/free-solid-svg-icons'
// import { faCircleUser } from '@fortawesome/free-regular-svg-icons'
import { faGooglePlus } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueCarousel from 'vue-carousel'
import VueI18n from 'vue-i18n'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueGtm from '@gtm-support/vue2-gtm'
import VueTypedJs from 'vue-typed-js'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import vClickOutside from 'v-click-outside'

const themeClasses = ['class01', 'class02', 'class03', 'class04', 'class05', 'classSuper', 'classMummy', 'classHalloween', 'classChristmas']
const defaultThemeClass = 'class01'

function syncThemeClass (route) {
  const today = new Date()
  const isHalloweenSeason = (today.getMonth() === 9 && today.getDate() >= 11) || (today.getMonth() === 10 && today.getDate() === 1)
  const isChristmasSeason = today.getMonth() === 11 && today.getDate() >= 4 && today.getDate() <= 25
  const seasonalThemeClass = isChristmasSeason ? 'classChristmas' : (isHalloweenSeason ? 'classHalloween' : defaultThemeClass)
  const routeTheme = route && route.query ? route.query.theme : null
  const themeParam = routeTheme || new URLSearchParams(window.location.search).get('theme')
  if (themeClasses.includes(themeParam)) {
    window.localStorage.setItem('siteTheme', themeParam)
    window.localStorage.setItem('siteThemeSource', 'query')
  } else if (themeParam === 'default') {
    window.localStorage.removeItem('siteTheme')
    window.localStorage.removeItem('siteThemeSource')
  }
  const storedTheme = window.localStorage.getItem('siteTheme')
  const storedThemeSource = window.localStorage.getItem('siteThemeSource')
  const canUseStoredTheme = themeClasses.includes(storedTheme) && (storedTheme !== 'class05' || storedThemeSource === 'query')
  const siteTheme = themeClasses.includes(themeParam) ? themeParam : (canUseStoredTheme ? storedTheme : seasonalThemeClass)
  const useClass01Theme = siteTheme === 'class01'
  const useClass02Theme = siteTheme === 'class02'
  const useClass03Theme = siteTheme === 'class03'
  const useClass04Theme = siteTheme === 'class04'
  const useClass05Theme = siteTheme === 'class05'
  const useClassChristmasTheme = siteTheme === 'classChristmas'
  const useClassHalloweenTheme = siteTheme === 'classHalloween'
  const useClassMummyTheme = siteTheme === 'classMummy'
  const useClassSuperTheme = siteTheme === 'classSuper' || useClassMummyTheme
  document.body.classList.toggle('class01', useClass01Theme || useClass02Theme || useClass03Theme || useClass04Theme || useClass05Theme || useClassSuperTheme || useClassHalloweenTheme || useClassChristmasTheme)
  document.body.classList.toggle('class02', useClass02Theme)
  document.body.classList.toggle('class03', useClass03Theme)
  document.body.classList.toggle('class04', useClass04Theme)
  document.body.classList.toggle('class05', useClass05Theme)
  document.body.classList.toggle('classHalloween', useClassHalloweenTheme)
  document.body.classList.toggle('classChristmas', useClassChristmasTheme)
  document.body.classList.toggle('classSuper', useClassSuperTheme)
  document.body.classList.toggle('classMummy', useClassMummyTheme)
}

syncThemeClass(router.currentRoute)
router.afterEach((to) => {
  syncThemeClass(to)
})

Vue.use(vClickOutside)
Vue.prototype.$video = videojs
Vue.use(VueTypedJs)
library.add(faCoffee, faGooglePlus, faBars, faArrowDown, faArrowRight, faTimes, faChevronRight, faEnvelopeOpenText, faEnvelope, faCheckCircle, faTimesCircle, faSignInAlt, faSignOutAlt, faBookOpen)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', vSelect)
Vue.use(VueCarousel)
Vue.use(VueSweetalert2)
Vue.use(VueI18n)
Vue.use(VueGtm, {
  id: 'GTM-WJ999TV', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  // queryParams: {
  //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
  //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview: 'env-4',
  //   gtm_cookies_win: 'x'
  // },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Disable GTM debug logging
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
})

// Create VueI18n instance with options
const locale = window.localStorage.getItem('locale') || 'tw'
const i18n = new VueI18n({
  locale: locale,
  messages: locales
})

Vue.config.productionTip = false
Vue.filter('dateFormat', function (daraStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(daraStr).format(pattern)
})
Vue.prototype.moment = moment
Vue.prototype.formatWord = function (val) {
  return val.replace(/\n/g, '<br>')
}
const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.auth.authorized) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
export { vm }
